// ============================================================
// ConfirmVisibilityModal.jsx
// PURPOSE:
// Sicherheitsabfrage beim Wechsel PUBLIC -> INTERN
// Erscheint direkt bei der betroffenen Schichtkachel
// ============================================================

import React from "react";
import "./confirmVisibilityModal.css";

const ConfirmVisibilityModal = ({ onConfirm, onCancel }) => {
	return (
		<div className="confirm-visibility-modal">
			<div className="modal-content">
				<h3>Schicht auf intern setzen?</h3>

				<p className="warning">
					⚠️ Diese Schicht hat bereits publizierte Plätze.<br />
					Ein Privatisieren macht sie für Libellen unsichtbar.
				</p>

				<div className="modal-buttons">
					<button className="modal-btn confirm" onClick={onConfirm}>
						Ja, auf intern setzen
					</button>
					<button className="modal-btn cancel" onClick={onCancel}>
						Abbrechen
					</button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmVisibilityModal;
